/** The demo tag this browser created, so the start page can link back to it. */
export interface SavedDemo {
  tagId: string;
  label: string;
  expiresAt: string;
}

const KEY = 'notlost.demo';

export function saveDemo(demo: SavedDemo, ownerKey: string): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(demo));
    localStorage.setItem(`notlost.owner.${demo.tagId}`, ownerKey);
  } catch {
    // Private mode. The owner link in the address bar still works this session.
  }
}

export function loadDemo(): SavedDemo | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const demo = JSON.parse(raw) as SavedDemo;
    return new Date(demo.expiresAt).getTime() > Date.now() ? demo : null;
  } catch {
    return null;
  }
}
